import cx from "clsx";
import { FileHandle } from "kreate-common/modules/business-types";
import { blobIdToUrl } from "kreate-env/client";
import React from "react";

import styles from "./index.module.scss";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  file: FileHandle | null | undefined;
  fill: true;
};

export default function PrimaryHtmlViewer({ className, style, file }: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      {file ? (
        <iframe className={styles.iframe} src={blobIdToUrl(file.blob.blobId)} />
      ) : undefined}
    </div>
  );
}
